module.exports = __webpack_public_path__ + "static/media/alert-chat-received.9e977607.mp3";